// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__esLOg","load6":"Spinner_load6__yALE1","round":"Spinner_round__GKKVu"};